import {
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { repoLensApiRef, RepoLensClient } from './api/RepoLensClient';

export const repoLensPlugin = createPlugin({
  id: 'repo-lens',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: repoLensApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RepoLensClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const RepoLensPage = repoLensPlugin.provide(
  createRoutableExtension({
    name: 'RepoLensPage',
    component: () =>
      import('./components/RepoLensPage').then(m => m.RepoLensPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityTechStackCard = repoLensPlugin.provide(
  createComponentExtension({
    name: 'EntityTechStackCard',
    component: {
      lazy: () =>
        import('./components/EntityTechStackCard').then(
          m => m.EntityTechStackCard,
        ),
    },
  }),
);

export const SystemTechStackCard = repoLensPlugin.provide(
  createComponentExtension({
    name: 'SystemTechStackCard',
    component: {
      lazy: () =>
        import('./components/EntityTechStackCard').then(
          m => m.SystemTechStackCard,
        ),
    },
  }),
);

export const EntityExternalServicesCard = repoLensPlugin.provide(
  createComponentExtension({
    name: 'EntityExternalServicesCard',
    component: {
      lazy: () =>
        import('./components/EntityTechStackCard').then(
          m => m.EntityExternalServicesCard,
        ),
    },
  }),
);
